













































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ProfiePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import CurrentDisciplinesSpecialities from './CurrentDisciplinesSpecialities.vue';
import { vxm } from './../../store.vuex';
import { CustomFieldsMetaData } from '@/models/userdata/customfieldsmetadata';
import { CustomFields } from '@/models/userdata/customfields';

@Component({
  name: 'DisciplineandSpecialties',
  components: {
    placeholder: ProfiePlaceholder,
    CurrentDisciplinesSpecialities,
  },
})
export default class DisciplineCustomField extends Vue {
  private dsExists: boolean = false;
  @Prop() viewMode;
  private discipline: string = '';
  private speciality: string = '';
  private selectedspecialities: string[] = [];
  private showDisciplines: boolean = false;
  private showHealthcare: boolean = false;
  private disciplinesEntries: Array<any> = [];
  private disciplinesEntriesBeforeFilter: Array<any> = [];
  $wlToastr: any;

  @Watch('disciplines')
  onChangeDisciplines(newList) {
    this.$emit('is-discipline-selected', newList.length);
  }

  disciplineOptions() {
    let output: any[] = [];
    let customFields: CustomFields = vxm.users.UserCustomMetaData;
    let userDisciplineMetaData: Array<CustomFieldsMetaData> = [];
    if (
      !this.lodash.isEmpty(customFields) &&
      !this.lodash.isEmpty(customFields.candidateCustomMetaData)
    ) {
      userDisciplineMetaData = customFields.candidateCustomMetaData;
    }
    if (!this.lodash.isEmpty(userDisciplineMetaData)) {
      const disciplineMetaData = userDisciplineMetaData.filter(
        (item) => item.label === 'Discipline',
      )[0];
      if (
        !this.lodash.isEmpty(disciplineMetaData) &&
        !this.lodash.isEmpty(disciplineMetaData.displayList)
      ) {
        const displayList = disciplineMetaData.displayList;
        const valueList = disciplineMetaData.valueList;
        const size = displayList ? displayList.length : 0;
        for (let i = 0; i < size; i++) {
          output.push({
            id: i,
            name: displayList[i],
            value: valueList[i],
            isSelected: false,
            key: disciplineMetaData.name,
          });
        }
      }

      let disciplineCustomData = disciplineMetaData.defaultValue;

      if (
        !this.lodash.isEmpty(disciplineCustomData) &&
        !this.lodash.isEmpty(output)
      ) {
        const userDisciplineData: Array<string> = disciplineCustomData.split(
          /\s*,\s*/,
        );
        output = output.map((item) => {
          if (userDisciplineData.includes(item.value)) {
            item.isSelected = true;
          }
          return item;
        });
      }
    }
    this.disciplinesEntries = output;
    this.disciplinesEntriesBeforeFilter = this.lodash.cloneDeep(output);
  }

  async mounted() {
    this.disciplineOptions();
  }

  get disciplines() {
    return this.disciplinesEntries.filter((item) => item.isSelected);
  }

  onDeleteDiscipline(discipline) {
    discipline.isSelected = false;
    this.ProcessRequest(discipline, 'D');
  }

  ProcessRequest(discipline, operation) {
    let map = {};
    this.disciplinesEntries.forEach((item) => {
      if (item.isSelected) {
        const key = item.key;
        if (map.hasOwnProperty(key)) {
          let values = map[key];
          values.push(item.value);
          map[key] = values;
        } else {
          map[key] = [item.value];
        }
      }
    });

    if (!this.lodash.isEmpty(map)) {
      for (const key in map) {
        let values = map[key];
        let value: string =
          values && Array.isArray(values)
            ? values.join(',')
            : values
            ? values
            : '';
        map[key] = value;
      }
    } else {
      if (!this.lodash.isEmpty(discipline) && !discipline.isSelected) {
        map[discipline.key] = '';
      }
    }

    this.addOrRemoveDiscipline(map, operation);
  }

  addDiscipline(discipline) {
    discipline.isSelected = true;
    this.ProcessRequest(discipline, 'A');
  }

  async addOrRemoveDiscipline(selectedDisciplines, operation) {
    const updateRespPromise: any = vxm.users.saveUserDisciplines(
      selectedDisciplines,
    );
    const updateResponse = await updateRespPromise;
    if (updateResponse.meta.success) {
      let successMessage =
        'A' === operation
          ? 'Discipline Selected Successfully!'
          : 'D' === operation
          ? 'Discipline is deleted!'
          : '';
      this.$wlToastr('success', successMessage, 'Discipline');
      await vxm.users.getSkills();
    } else {
      this.$wlToastr('error', updateResponse.errorMessage, '');
    }
  }

  toggleCategories(categoryname: string) {
    if (categoryname == 'disciplines')
      this.showDisciplines = !this.showDisciplines;
    if (categoryname == 'healthcare')
      this.showHealthcare = !this.showHealthcare;
  }

  isSelected(category: string, id: number): boolean {
    if (category == 'disciplines') {
      if (id == 1) {
        return true;
      }
    }
    if (category == 'healthcare') {
      if (id == 2) {
        return true;
      }
    }
    return false;
  }

  getSearchedDiscipline(searchVal: string) {
    let filteredDisciplinesEntries = this.lodash.cloneDeep(
      this.disciplinesEntriesBeforeFilter,
    );
    if (!this.lodash.isEmpty(filteredDisciplinesEntries)) {
      filteredDisciplinesEntries = filteredDisciplinesEntries.filter((item) => {
        let index = item.name.toLowerCase().search(searchVal.toLowerCase());

        if (index >= 0) {
          return item;
        } else {
          return null;
        }
      });
    }
    this.disciplinesEntries = filteredDisciplinesEntries;
  }
}
